'use client'

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import LanguageSwitcher from '@/components/shared/languageSelect'
import ContentBlockFormBody from './ContentBlockFormBody'
import type { ContentBlockItem } from './DraggableContentBlockItem'

export type { ContentBlockItem }

interface InlineContentBlockFormProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  blockId: number | null
  onCreated: (block: ContentBlockItem) => void
  onUpdated: (block: ContentBlockItem) => void
}

export default function InlineContentBlockForm({
  open,
  onOpenChange,
  blockId,
  onCreated,
  onUpdated,
}: InlineContentBlockFormProps) {
  const isEditMode = blockId !== null

  const handleCreated = (block: ContentBlockItem) => {
    onCreated(block)
    onOpenChange(false)
  }

  const handleUpdated = (block: ContentBlockItem) => {
    onUpdated(block)
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-2xl max-h-[90vh]"
        onPointerDownOutside={e => e.preventDefault()}
        onInteractOutside={e => e.preventDefault()}
      >
        <DialogHeader>
          <div className="flex justify-between items-center pr-6">
            <DialogTitle>
              {isEditMode ? 'Edit Content Block' : 'Create Content Block'}
            </DialogTitle>
            <LanguageSwitcher />
          </div>
        </DialogHeader>

        <ContentBlockFormBody
          key={open ? (blockId ?? 'new') : 'closed'}
          blockId={blockId}
          onCreated={handleCreated}
          onUpdated={handleUpdated}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  )
}
